// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_3id","cls2":"ReportList-cls2_Sev ReportList-cls1_3id"};